export const useTranslations = () => {
    const { $i18n } = useNuxtApp()

    const setTranslations = (translations) => {
        Object.keys(translations).forEach((key: string) => {
            updateTranslation(key, translations[key]);
        });
    };

    const updateTranslation = (key: string, text: string): void => {
        if (key.startsWith('*.')) {
            key = key.substring(2);
        }
        key = key.replace(/\//g, '.');

        let escapedText = text;

        escapedText = escapedText
            .replace(/:([a-zA-Z0-9_]+)/g, (_match, p1) => `__PH_${p1}__`)
            .replace(/'/g, "\\'")                         // escape single quotes
            .replace(/@/g, "{'@'}")                         // @ - message linking
            .replace(/\|/g, "{'|'}")                       // | - pluralization separator
            .replace(/\$/g, "{'$'}")                       // $ - named interpolation
            .replace(/#/g, "{'#'}")                         // # - list interpolation
            .replace(/\^/g, "{'^'}")                       // ^ - caret
            .replace(/\\/g, "{'\\\\'}")               // \\ - backslash (double-escaped for JS string and compiler)
            .replace(/\{/g, "{'\\u007b'}")               // { -> unicode literal for '{'
            .replace(/\}/g, "{'\\u007d'}");              // } -> unicode literal for '}'

        escapedText = escapedText.replace(/__PH_([a-zA-Z0-9_]+)__/g, '{$1}');

        $i18n.setLocaleMessage($i18n.locale.value, {
            ...$i18n.getLocaleMessage($i18n.locale.value),
            [key]: escapedText
        });
    }

    return {
        setTranslations,
        updateTranslation,
    }
}
